<div class="app-layout full-height">
  <app-sidebar-layout
    (openSidebar)="openSidebar()"
    (closeSidebar)="closeSidebar()"
  ></app-sidebar-layout>

  <section id="page-container" class="app-page-container">
    <app-header-layout
      (openSidebar)="openSidebar()"
      (closeSidebar)="closeSidebar()"
    ></app-header-layout>

    <div id="app-content-wrapper" class="app-content-wrapper">
      <div class="app-content">
        <div class="full-height">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </section>
</div>
